if (document.body) { document.body.classList.add('hgb-js'); } else { document.addEventListener('DOMContentLoaded', function(){ document.body.classList.add('hgb-js'); }); }
/* HOLYGRADE «Bühne» · Theme-Skript (Shopify-Portierung, Stand 14.09.2026)
   Aufgaben laut JS-Vertrag (shopify_port/CONTRACTS.md):
   1. Einblenden beim Scrollen: .hgb-reveal -> .hgb-sichtbar
   2. Menü-Toggle [data-hgb-menu] -> body.hgb-nav-open
   3. [data-hgb-open="cart"] öffnet den Dawn Cart-Drawer (sonst /cart),
      [data-hgb-open="search"] fokussiert die Predictive Search (sonst /search)
   4. Add-to-cart: form.hgb-product-form per fetch an routes.cart_add_url,
      Antwort in den Dawn-Drawer (renderContents), Fallback: Formular normal absenden
   5. Mengenfeld [data-hgb-qty] mit −/+
   6. Vorbestellungen clientseitig nach data-hgb-release sortieren
   Kein localStorage, keine Analytics, kein Framework. */
(function () {
  'use strict';

  var doc = document;
  var routes = window.routes || {};
  var CART_ADD = routes.cart_add_url || '/cart/add';
  var CART_URL = routes.cart_url || '/cart';
  var SEARCH_URL = (routes.search_url) || '/search';

  function $(sel, root) { return (root || doc).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }

  /* ---------- 1. Einblenden ---------- */
  var beobachter = null;
  function observeReveal() {
    var ziele = $$('.hgb-reveal:not(.hgb-sichtbar)');
    if (!ziele.length) return;
    if (!('IntersectionObserver' in window)) {
      ziele.forEach(function (el) { el.classList.add('hgb-sichtbar'); });
      return;
    }
    if (!beobachter) {
      beobachter = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('hgb-sichtbar');
            beobachter.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -12% 0px' });
    }
    ziele.forEach(function (el) { beobachter.observe(el); });
  }

  /* ---------- 2. Menü ---------- */
  function setNav(open) {
    doc.body.classList.toggle('hgb-nav-open', open);
    $$('[data-hgb-menu]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    var nav = $('.hgb-site-nav');
    if (nav) nav.classList.toggle('hgb-open', open);
  }
  function toggleNav() { setNav(!doc.body.classList.contains('hgb-nav-open')); }

  /* ---------- 3. Warenkorb / Suche öffnen ---------- */
  function cartDrawer() { return doc.querySelector('cart-drawer'); }

  function openCart(trigger) {
    var drawer = cartDrawer();
    if (drawer) {
      if (typeof drawer.open === 'function') {
        drawer.open(trigger || null);
      } else {
        drawer.classList.add('animate', 'active');
        doc.body.classList.add('overflow-hidden');
      }
      return true;
    }
    window.location.href = CART_URL;
    return false;
  }

  function setSearch(open) {
    doc.body.classList.toggle('hgb-search-open', open);
    $$('[data-hgb-open="search"]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) {
      var input = $('.hgb-search-bar input[type="search"]') || $('predictive-search input[type="search"]');
      if (input) { input.focus(); input.select(); }
    }
  }

  function openSearch(trigger) {
    if (trigger && trigger.getAttribute('data-hgb-url')) SEARCH_URL = trigger.getAttribute('data-hgb-url');
    var bar = $('.hgb-search-bar');
    if (bar) { setSearch(!doc.body.classList.contains('hgb-search-open')); return; }
    /* Kein eigenes Suchfeld im Kopf: Dawn Predictive Search fokussieren, sonst /search */
    var dawnInput = $('predictive-search input[type="search"]');
    if (dawnInput) {
      var details = dawnInput.closest('details');
      if (details) details.setAttribute('open', '');
      dawnInput.focus();
      return;
    }
    window.location.href = SEARCH_URL;
  }

  /* ---------- 4. Add-to-cart ---------- */
  function wantedSections() {
    var list = [];
    if (cartDrawer()) list.push('cart-drawer');
    else if (doc.querySelector('cart-notification')) list.push('cart-notification');
    if (doc.getElementById('cart-icon-bubble')) list.push('cart-icon-bubble');
    return list;
  }

  function updateCartCount(count) {
    $$('[data-hgb-cart-count]').forEach(function (el) { el.textContent = String(count); });
  }

  function refreshBubbleFromSections(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var target = doc.getElementById('cart-icon-bubble');
    if (!target) return;
    var tmp = doc.createElement('div');
    tmp.innerHTML = sections['cart-icon-bubble'];
    var inner = tmp.querySelector('.shopify-section') || tmp;
    target.innerHTML = inner.innerHTML;
  }

  function setBusy(form, busy) {
    var btn = form.querySelector('[type="submit"]');
    if (!btn) return;
    btn.disabled = !!busy;
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
    if (busy) {
      btn.setAttribute('data-hgb-label', btn.textContent);
      btn.textContent = btn.getAttribute('data-hgb-busy-label') || (window.hgbI18n && window.hgbI18n.busy) || 'Wird hinzugefügt …';
    } else if (btn.hasAttribute('data-hgb-label')) {
      btn.textContent = btn.getAttribute('data-hgb-label');
      btn.removeAttribute('data-hgb-label');
    }
  }

  function showFormError(form, message) {
    var box = form.querySelector('[data-hgb-form-error]');
    if (!box) return;
    box.textContent = message || '';
    box.hidden = !message;
  }

  function submitProductForm(form) {
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value || !window.fetch || !window.FormData) return false; /* -> normaler Submit */
    var fd = new FormData(form);
    var qtyInput = form.querySelector('[name="quantity"]');
    if (qtyInput && !fd.has('quantity')) fd.append('quantity', qtyInput.value || '1');
    var sections = wantedSections();
    if (sections.length) {
      fd.append('sections', sections.join(','));
      fd.append('sections_url', window.location.pathname);
    }
    setBusy(form, true);
    showFormError(form, '');
    fetch(CART_ADD + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function (r) {
      return r.json().then(function (json) { return { ok: r.ok, json: json }; });
    }).then(function (res) {
      setBusy(form, false);
      var parsed = res.json || {};
      if (!res.ok || parsed.status) {
        showFormError(form, parsed.description || parsed.message || (window.hgbI18n && window.hgbI18n.addError) || (window.cartStrings && window.cartStrings.error) || 'Der Artikel konnte nicht hinzugefügt werden.');
        return;
      }
      var drawer = cartDrawer();
      var notif = doc.querySelector('cart-notification');
      if (drawer && typeof drawer.renderContents === 'function' && parsed.sections) {
        try {
          drawer.renderContents(parsed);          /* füllt Items und öffnet den Drawer (Dawn) */
          drawer.classList.remove('is-empty');
          if (!drawer.classList.contains('active') && typeof drawer.open === 'function') drawer.open();
          return;
        } catch (e) { /* weiter zum Fallback */ }
      }
      if (notif && typeof notif.renderContents === 'function' && parsed.sections) {
        try { notif.renderContents(parsed); return; } catch (e) { /* weiter */ }
      }
      refreshBubbleFromSections(parsed.sections);
      if (drawer) { drawer.classList.remove('is-empty'); openCart(); return; }
      window.location.href = CART_URL;
    }).catch(function () {
      setBusy(form, false);
      /* Netzwerkfehler: Formular klassisch absenden (Shopify leitet auf /cart) */
      form.removeAttribute('data-hgb-ajax');
      form.setAttribute('data-hgb-fallback', '1');
      form.submit();
    });
    return true;
  }

  /* ---------- 5. Mengenfeld ----------
     Zwei Schreibweisen werden unterstützt:
     a) <button data-hgb-qty="-1">  … <input name="quantity" data-hgb-qty-input> … <button data-hgb-qty="1">
        (Eingabefeld wird im nächsten gemeinsamen Formular / Wrapper gesucht)
     b) <div data-hgb-qty><button data-hgb-step="-1">…<input name="quantity">…<button data-hgb-step="1"></div> */
  function findQtyInput(button) {
    var scope = button.closest('[data-hgb-qty-wrap], .hgb-qty, form') || button.parentNode;
    return scope.querySelector('[data-hgb-qty-input], input[name="quantity"], input[type="number"]');
  }
  function stepQty(button, delta) {
    var input = findQtyInput(button);
    var output = (button.closest('[data-hgb-qty-wrap], .hgb-qty') || button.parentNode).querySelector('output');
    var cur = Number((input && input.value) || (output && output.textContent) || 1) || 1;
    var min = Number((input && input.min) || 1) || 1;
    var max = Number((input && input.max) || 99) || 99;
    var next = Math.max(min, Math.min(max, cur + delta));
    if (input) { input.value = String(next); input.dispatchEvent(new Event('change', { bubbles: true })); }
    if (output) output.textContent = String(next);
  }
  function qtyDelta(el) {
    var wrap = el.closest('[data-hgb-qty]');
    var step = el.closest('[data-hgb-step]');
    if (step && wrap) return Number(step.getAttribute('data-hgb-step')) || 0;          /* Variante b */
    var btn = el.closest('button[data-hgb-qty], a[data-hgb-qty]');
    if (btn) return Number(btn.getAttribute('data-hgb-qty')) || 0;                     /* Variante a */
    return 0;
  }

  /* ---------- 6. Vorbestellungen sortieren ---------- */
  function sortReleases() {
    var heute = new Date();
    var isoHeute = heute.getFullYear() + '-' + String(heute.getMonth() + 1).padStart(2, '0') + '-' + String(heute.getDate()).padStart(2, '0');
    $$('[data-hgb-sort-release]').forEach(function (box) {
      var items = $$('[data-hgb-release]', box).filter(function (el) { return el.parentNode === box; });
      if (items.length < 2) return;
      var rang = function (el) {
        var r = el.getAttribute('data-hgb-release') || '';
        if (!/^\d{4}-\d{2}-\d{2}$/.test(r)) return 2;
        return r >= isoHeute ? 0 : 1;          /* kommende zuerst, erschienene danach, ohne Datum zuletzt */
      };
      var sorted = items.slice().sort(function (a, b) {
        var d = rang(a) - rang(b);
        if (d) return d;
        return String(a.getAttribute('data-hgb-release') || '9').localeCompare(String(b.getAttribute('data-hgb-release') || '9'));
      });
      var changed = sorted.some(function (el, i) { return el !== items[i]; });
      if (!changed) return;
      sorted.forEach(function (el) { box.appendChild(el); });
    });
  }

  /* ---------- Kopf: Haarlinie beim Scrollen ---------- */
  function watchScroll() {
    var header = $('.hgb-site-header');
    if (!header) return;
    var apply = function () { header.classList.toggle('hgb-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', apply, { passive: true });
    apply();
  }

  /* ---------- Ereignisse ---------- */
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    var menu = t.closest('[data-hgb-menu]');
    if (menu) { e.preventDefault(); toggleNav(); return; }

    var opener = t.closest('[data-hgb-open]');
    if (opener) {
      var was = opener.getAttribute('data-hgb-open');
      if (was === 'cart') {
        if (cartDrawer()) {
          e.preventDefault();
          /* Dawn bindet #cart-icon-bubble selbst; nur öffnen, wenn Dawn es nicht schon tut */
          if (opener.id !== 'cart-icon-bubble' || !cartDrawer()._cartClickBound) openCart(opener);
        }
        return;
      }
      if (was === 'search') { e.preventDefault(); openSearch(opener); return; }
    }

    var closeSearch = t.closest('[data-hgb-close="search"]');
    if (closeSearch) { e.preventDefault(); setSearch(false); return; }

    var delta = qtyDelta(t);
    if (delta) { e.preventDefault(); stepQty(t.closest('button, a') || t, delta); return; }

    /* Klick ausserhalb schliesst Menü / Suche */
    if (doc.body.classList.contains('hgb-nav-open') && !t.closest('.hgb-site-header')) setNav(false);
    if (doc.body.classList.contains('hgb-search-open') && !t.closest('.hgb-site-header')) setSearch(false);
  });

  doc.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('hgb-product-form')) return;
    if (form.hasAttribute('data-hgb-fallback')) return;
    if (submitProductForm(form)) e.preventDefault();
  });

  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (doc.body.classList.contains('hgb-search-open')) setSearch(false);
    if (doc.body.classList.contains('hgb-nav-open')) setNav(false);
  });

  /* Menü nach Navigation im Theme-Editor / bei Section-Neuladen zurücksetzen */
  doc.addEventListener('shopify:section:load', function () { observeReveal(); sortReleases(); });

  function init() {
    observeReveal();
    sortReleases();
    watchScroll();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();

  /* Kleine öffentliche Schnittstelle für andere hgb-Skripte (z. B. Zähler nach Änderungen) */
  window.hgbStage = { openCart: openCart, openSearch: openSearch, updateCartCount: updateCartCount, observeReveal: observeReveal, sortReleases: sortReleases };
})();

/* HGB Währung: Hinweisbeträge in CHF (Versand, Schwellen) für Nicht-CHF-Märkte per Shopify.currency.rate umrechnen; Versandbalken in Präsentationswährung nachrechnen. */
(function(){
  var cur = window.Shopify && window.Shopify.currency;
  if (!cur || !cur.active || cur.active === 'CHF' || !cur.rate) return;
  var rate = parseFloat(cur.rate); if (!rate || rate <= 0) return;
  function fmt(v){ return cur.active + '\u00a0' + v.toFixed(2); }
  function convertText(root){
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: function(n){
      var p = n.parentElement; if (!p) return NodeFilter.FILTER_REJECT;
      if (/^(SCRIPT|STYLE|TEXTAREA|INPUT|NOSCRIPT)$/.test(p.tagName)) return NodeFilter.FILTER_REJECT;
      if (p.closest('[data-hgb-noconvert]')) return NodeFilter.FILTER_REJECT;
      return /CHF\s?\d|Preise in CHF|prices in CHF/.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }});
    var nodes = []; while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function(n){
      n.nodeValue = n.nodeValue
        .replace(/CHF\s?(\d{1,3}(?:['’]\d{3})*(?:[.,]\d{1,2})?|\d{1,6}(?:[.,]\d{1,2})?)/g, function(m, a){ return fmt(parseFloat(a.replace(/['’]/g, '').replace(',', '.')) * rate); })
        .replace(/Preise in CHF/g, 'Preise in ' + cur.active).replace(/prices in CHF/g, 'prices in ' + cur.active);
    });
  }
  function shipbar(){
    document.querySelectorAll('.hg-shipbar[data-hgb-threshold-chf]').forEach(function(el){
      if (el.dataset.hgbDone) return; el.dataset.hgbDone = '1';
      var thr = parseInt(el.dataset.hgbThresholdChf, 10) * rate, total = parseInt(el.dataset.hgbTotal, 10);
      if (!thr || isNaN(total)) return;
      var missing = thr - total, pct = Math.min(100, Math.round(total * 100 / thr)), en = el.dataset.hgbEn === 'true';
      var t = el.querySelector('.hg-shipbar__text'), bar = el.querySelector('.hg-shipbar__bar');
      if (missing > 0) {
        el.classList.remove('hg-shipbar--done');
        if (t) t.innerHTML = en ? 'Still <span class="hg-shipbar__amount">' + fmt(missing / 100) + '</span> to free shipping' : 'Noch <span class="hg-shipbar__amount">' + fmt(missing / 100) + '</span> bis zum Gratisversand';
      } else {
        el.classList.add('hg-shipbar--done'); pct = 100;
        if (t && el.dataset.hgbZoneKnown === 'true') t.textContent = en ? 'Shipping is free for this order' : 'Versand ist f\u00fcr diese Bestellung kostenlos';
      }
      if (bar) bar.style.width = pct + '%';
    });
  }
  var timer; function run(){ shipbar(); convertText(document.body); }
  new MutationObserver(function(){ clearTimeout(timer); timer = setTimeout(run, 80); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
